var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarGradient(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16551_75862)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.58984 5.23438H5.83203C6.19922 5.23438 6.49609 4.9375 6.49609 4.57031V0.664062C6.49609 0.296875 6.19922 0 5.83203 0H4.58984C4.22266 0 3.92578 0.296875 3.92578 0.664062V4.57031C3.92578 4.9375 4.22266 5.23438 4.58984 5.23438Z",
    fill: "url(#paint0_linear_16551_75862)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1641 5.23438H15.4102C15.7773 5.23438 16.0742 4.9375 16.0742 4.57031V0.664062C16.0742 0.296875 15.7773 0 15.4102 0H14.1641C13.7969 0 13.5 0.296875 13.5 0.664062V4.57031C13.5 4.9375 13.7969 5.23438 14.1641 5.23438Z",
    fill: "url(#paint1_linear_16551_75862)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7539 2.67188H16.6523V4.57031C16.6523 5.25781 16.0938 5.81641 15.4062 5.81641H14.1602C13.4727 5.81641 12.9141 5.25781 12.9141 4.57031V2.67188H7.07812V4.57031C7.07812 5.25781 6.51953 5.81641 5.83203 5.81641H4.58594C3.89844 5.81641 3.33984 5.25781 3.33984 4.57031V2.67188H2.24609C1.00391 2.67188 0 3.67969 0 4.91797V7.65234H20V4.91797C20 3.67969 18.9961 2.67188 17.7539 2.67188Z",
    fill: "url(#paint2_linear_16551_75862)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 8.23438V17.7578C0 18.9961 1.00391 20 2.24219 20H17.7539C18.9922 20 20 18.9961 20 17.7578V8.23438H0ZM14.0195 13.3281L12.4336 14.875L12.8086 17.0586C12.8633 17.375 12.6484 17.6797 12.332 17.7305C12.207 17.7539 12.0742 17.7305 11.9609 17.6719L10 16.6406L8.03906 17.6719C7.75391 17.8203 7.40234 17.7109 7.25 17.4258C7.19141 17.3125 7.17188 17.1836 7.19141 17.0547L7.56641 14.8711L5.98047 13.3242C5.75 13.0977 5.74609 12.7305 5.96875 12.5C6.05859 12.4102 6.17578 12.3477 6.30078 12.332L8.49219 12.0117L9.47266 10.0234C9.61328 9.73438 9.96484 9.61719 10.2539 9.75781C10.3672 9.81641 10.4609 9.90625 10.5195 10.0234L11.5 12.0117L13.6914 12.332C14.0117 12.3789 14.2305 12.6758 14.1836 12.9922C14.168 13.1211 14.1094 13.2383 14.0195 13.3281Z",
    fill: "url(#paint3_linear_16551_75862)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16551_75862",
    x1: 3.18103,
    y1: -1.41764,
    x2: 7.93135,
    y2: -1.1466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0BA0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345263,
    stopColor: "#CB2129"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563723,
    stopColor: "#CB2129"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0BA0E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_16551_75862",
    x1: 12.7541,
    y1: -1.41764,
    x2: 17.5116,
    y2: -1.14578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0BA0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345263,
    stopColor: "#CB2129"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563723,
    stopColor: "#CB2129"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0BA0E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_16551_75862",
    x1: -5.79506,
    y1: 1.323,
    x2: 24.6581,
    y2: 15.5325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0BA0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345263,
    stopColor: "#CB2129"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563723,
    stopColor: "#CB2129"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0BA0E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_16551_75862",
    x1: -5.79506,
    y1: 5.04785,
    x2: 29.8959,
    y2: 12.0974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0BA0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345263,
    stopColor: "#CB2129"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563723,
    stopColor: "#CB2129"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0BA0E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16551_75862"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarGradient);
export default __webpack_public_path__ + "static/media/calendar-gradient.35f2b4878942fa908bd649b63a5f002d.svg";
export { ForwardRef as ReactComponent };